export const DELETE_AUTO = 'DELETE_AUTO'
export const SET_LOADING_STATS = 'SET_LOADING_STATS'
export const FETCH_AUTOS_STATS = 'FETCH_AUTOS_STATS'
